import DemoShell from '@/components/demo/DemoShell'
import Seo from '@/components/Seo'

export default function DemoPage() {
  return (
    <>
      <Seo path="/demo" />
      <DemoShell />
    </>
  )
}
